export default __webpack_public_path__ + "static/img01-cecd7cf16bc95c6d8414a126a026e1d3.png";